import React, { Component } from 'react';
import { Row, Col, Card, CardBody, Input, InputGroupAddon, Button } from 'reactstrap';
import { Redirect, withRouter } from '../../utils/router-compat';
import classnames from 'classnames';
import _ from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';

import MemberSalesDetailDataTable from '../../components/SalesReport/MemberSalesDetailDataTable';
import SalesReportService from '../../services/SalesReportService';
import CustomSpinner from '../../components/CustomSpinner/CustomSpinner';

class MemberSalesDetail extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isMonthPickerOpen: false,
      years: this.getYears(),
      months: this.getMonths(),
      selectedYear: new Date().getFullYear(),
      selectedMonth: this.getSelectedMonth(),
      redirectToSalesReport: false,
      isLoading: false,
      fleetSalesZFM: [],
      totalFleetSalesZFM: {},
      queryParams: {}
    };
  }

  componentWillMount() {
    let { queryParams } = this.state;
    const query = new URLSearchParams(this.props.location.search);

    queryParams = {
      uuid: window.atob(query.get('uuid')),
      name: window.atob(query.get('name')),
      memberId: window.atob(query.get('memberId')),
      location: window.atob(query.get('location')),
      month: query.get('month'),
      label: query.get('label'),
      year: query.get('year'),
    };

    let obj = null;
    let selectedYear = null;
    if (queryParams.month && queryParams.label) {
      obj = {
        value: parseInt(queryParams.month),
        label: queryParams.label
      };
    }
    if (queryParams.year) {
      selectedYear = parseInt(queryParams.year);
    }

    if (obj && selectedYear) {
      this.setState({ selectedMonth: obj, selectedYear }, () => {
        this.getFleetSalesTotalReportZFM(queryParams.uuid);
        this.getFleetSalesReportZFM(1, 10, false, queryParams.uuid);
      });
    } else {
      this.getFleetSalesTotalReportZFM(queryParams.uuid);
      this.getFleetSalesReportZFM(1, 10, false, queryParams.uuid);
    }
    this.setState({ queryParams });
  }

  componentDidMount() {
    let { isMonthPickerOpen } = this.state;
    const that = this;
    window.addEventListener('click', function handleClick(e) {
      if ((document.getElementById('monthYearCalendarDiv') && document.getElementById('monthYearCalendarDiv').contains(e.target)) || (document.getElementById('monthYearCalendarInput') && document.getElementById('monthYearCalendarInput').contains(e.target))) {
        // Clicked in box
        isMonthPickerOpen = true;
        that.setState({ isMonthPickerOpen });

      } else {
        isMonthPickerOpen = false;
        that.setState({ isMonthPickerOpen });
        // Clicked outside the box
      }
    });
  }

  openMonthPicker = () => {
    let { isMonthPickerOpen } = this.state;
    isMonthPickerOpen = !isMonthPickerOpen;
    this.setState({ isMonthPickerOpen });
  }

  getYears = () => {
    const arr = [];
    for (let i = new Date().getFullYear(); i >= 1970; i--) {
      arr.push(i);
    }

    return arr;
  }

  getMonths = () => {
    return [{
      label: 'Jan',
      value: 1
    },
    {
      label: 'Feb',
      value: 2
    },
    {
      label: 'Mar',
      value: 3
    },
    {
      label: 'Apr',
      value: 4
    },
    {
      label: 'May',
      value: 5
    },
    {
      label: 'Jun',
      value: 6
    },
    {
      label: 'Jul',
      value: 7
    },
    {
      label: 'Aug',
      value: 8
    },
    {
      label: 'Sep',
      value: 9
    },
    {
      label: 'Oct',
      value: 10
    },
    {
      label: 'Nov',
      value: 11
    },
    {
      label: 'Dec',
      value: 12
    }
    ];
  }

  getSelectedMonth = () => {
    return _.find(this.getMonths(), { value: new Date().getMonth() + 1 });
  }

  handleYearChange = (e) => {
    const { queryParams } = this.state;
    let { selectedYear } = this.state;
    selectedYear = e.target.value;
    this.setState({ selectedYear }, () => {
      this.getFleetSalesTotalReportZFM(queryParams.uuid);
      this.getFleetSalesReportZFM(1, 10, false, queryParams.uuid);
    });
  }

  handleMonthChange = (obj) => {
    const { queryParams } = this.state;
    let { selectedMonth, isMonthPickerOpen } = this.state;
    selectedMonth = obj;
    isMonthPickerOpen = !isMonthPickerOpen;
    this.setState({ selectedMonth, isMonthPickerOpen }, () => {
      this.getFleetSalesTotalReportZFM(queryParams.uuid);
      this.getFleetSalesReportZFM(1, 10, false, queryParams.uuid);
    });
  }

  goToSaleReport = () => {
    let { redirectToSalesReport } = this.state;
    redirectToSalesReport = true;
    this.setState({ redirectToSalesReport });
  }


  getFleetSalesReportZFM = async (page, pagesize, downloadReport, uuid) => {
    const { selectedMonth, selectedYear } = this.state;
    let { fleetSalesZFM, isLoading } = this.state;
    try {
      isLoading = true;
      this.setState({ isLoading });
      const { data } = await SalesReportService.getFleetSalesReportZFM({ month: selectedMonth.value, year: selectedYear, page, pagesize, downloadReport, uuid });

      if (downloadReport && data) {
        const link = document.createElement('a');
        link.href = data.data.file;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
      else if (data) {
        fleetSalesZFM = data.data;
        fleetSalesZFM.pageCount = Math.trunc(fleetSalesZFM.total_count / 10) + 1;
        fleetSalesZFM.page = page;
      }
      isLoading = false;
      this.setState({ isLoading, fleetSalesZFM });
    } catch (error) {
      isLoading = false;
      this.setState({ isLoading });
    }
  }

  handlePageClick = (e) => {
    let { isLoading } = this.state;
    const { queryParams } = this.state;
    isLoading = true;
    this.setState({ isLoading });
    this.getFleetSalesReportZFM(e.selected + 1, 10, false, queryParams.uuid);
  }

  getFleetSalesTotalReportZFM = async (uuid) => {
    const { selectedMonth, selectedYear } = this.state;
    let { totalFleetSalesZFM } = this.state;
    try {
      const { data } = await SalesReportService.getFleetSalesTotalReportZFM({ month: selectedMonth.value, year: selectedYear, uuid });
      if (data) {
        totalFleetSalesZFM = data.data;
      }
      this.setState({ totalFleetSalesZFM });

    } catch (error) { }
  }


  // deleteSales = (sales) => {
  //   let obj = {
  //     id: sales.uuid
  //   }
  //   SalesReportService.deleteSales(obj)
  //     .then(data => {
  //       const { uuid } = this.state.queryParams;
  //       this.getFleetSalesReportZFM(1, 10, false, uuid);
  //     })
  //     .catch(e => {
  //       console.error("e", e);
  //     })
  // }

  reloadDataOnDelete = () => {
    const { uuid } = this.state.queryParams;
    this.getFleetSalesTotalReportZFM(uuid);
    this.getFleetSalesReportZFM(1, 10, false, uuid);
  }

  render() {
    console.log("rendering MemberSalesDetail");
    const { isLoading, queryParams, fleetSalesZFM, totalFleetSalesZFM, redirectToSalesReport, isMonthPickerOpen, years, months, selectedMonth, selectedYear } = this.state;
    return (
      <div>
        {isLoading && <CustomSpinner />}
        {redirectToSalesReport && <Redirect to='/salesReport' />}
        <Row>
          <Col>
            <div style={{ display: 'flex' }}>
              <span onClick={this.goToSaleReport} className="select-vehicle-label" style={{ color: '#545cd8', cursor: 'pointer' }}>Sales Report</span>
              &nbsp;&nbsp;
              <FontAwesomeIcon icon={faAngleRight} style={{ fontSize: '26px', cursor: 'pointer', marginTop: '-5px' }} color="#fdbb1f" />
              &nbsp;&nbsp;
              <span className="Offtake-Entry---Invo" style={{ textTransform: 'uppercase' }}>Details of {queryParams.name} ({queryParams.memberId}), {queryParams.location}</span>
            </div>
          </Col>
        </Row>

        <Row className="c-top-15">
          <Col xl="3" md="3" sm="3" xs="3">
            <div id="monthYearCalendarInput" className="d-flex-row vehical-sku-id-search">
              <Input
                className="form-control"
                type="text"
                name="sap_id"
                value={selectedMonth && `${selectedMonth.label} ${selectedYear}`}
                onClick={this.openMonthPicker}
                readOnly
                style={{ background: 'white' }}
                placeholder="Select Month" />
              <InputGroupAddon onClick={this.openMonthPicker} addonType="append" className="serach-icon" style={{ marginTop: '0px' }}>
                <div className="input-group-text" style={{ paddingRight: '5px', marginTop: '-1px' }}>
                  <FontAwesomeIcon icon={faCalendarAlt} />
                </div>
              </InputGroupAddon>
            </div>
          </Col>
        </Row>

        {isMonthPickerOpen &&

          <Row id="monthYearCalendarDiv" style={{ position: 'absolute', zIndex: '100' }}>
            <Col xl="4" md="4" sm="4" xs="4">
              <Card style={{ width: '97%' }}>
                <CardBody>
                  <Row>
                    <Col>
                      <select className="form-control" name="selectYear"
                        onChange={(e) => this.handleYearChange(e)} value={selectedYear}>
                        {
                          (years || []).map((year) => (
                            <option key={year}>{year}</option>
                          ))
                        }
                      </select>
                    </Col>
                  </Row>

                  <Row className="c-top-10">
                    {
                      (months || []).map((month) => (
                        <Col xl="4" md="4" sm="3" xs="3" key={month.value}>
                          <div>
                            <Button className="btn-month" color="default" onClick={(e) => this.handleMonthChange(month)}>{month.label}</Button>
                          </div>
                        </Col>
                      ))
                    }

                  </Row>

                </CardBody>
              </Card>
            </Col>
          </Row>
        }

        <Row style={{ marginTop: '20px' }}>
          <Col xl="3" md="3" sm="12" xs="12">
            <div className={classnames({ 'mr-3': !this.isMobile }, 'fm-points-card total-points-card')} style={{ paddingBottom: '0px' }}>
              <Row>
                <Col xl="8" md="8" sm="12" xs="12">
                  <div className="fm-trucks">TBR</div>
                </Col>
              </Row>

              <Row style={{ marginLeft: '7px', marginTop: '18px' }}>
                <Col xl="6" md="6" sm="12" xs="12">
                  <div className="direct-sales-label">Direct Sales</div>
                  <br />
                  {/* <div className="direct-sales-label">Indirect Sales</div> */}
                </Col>
                <Col xl="6" md="6" sm="12" xs="12">
                  <div className="direct-indirect-sales-value">{totalFleetSalesZFM.direct_tbr}</div>
                  <br />
                  {/* <div className="direct-indirect-sales-value">{totalFleetSalesZFM.indirect_tbr}</div> */}
                </Col>
              </Row>

              <Row className="c-top-10" style={{ marginRight: '0px', marginLeft: '0px', background: 'white', paddingBottom: '10px', paddingTop: '10px' }}>
                <Col xl="6" md="6" sm="12" xs="12">
                  <div className="direct-sales-label">&nbsp;Total Sales</div>
                </Col>
                <Col xl="6" md="6" sm="12" xs="12">
                  <div className="direct-indirect-sales-value">&nbsp;&nbsp;{totalFleetSalesZFM.total_tbr}</div>
                </Col>
              </Row>
            </div>
          </Col>

          <Col xl="3" md="3" sm="12" xs="12">
            <div className={classnames({ 'mr-3': !this.isMobile }, 'fm-points-card total-points-card')} style={{ paddingBottom: '0px' }}>
              <Row>
                <Col xl="8" md="8" sm="12" xs="12">
                  <div className="fm-trucks">TBB</div>
                </Col>
              </Row>

              <Row style={{ marginLeft: '7px', marginTop: '18px' }}>
                <Col xl="6" md="6" sm="12" xs="12">
                  <div className="direct-sales-label">Direct Sales</div>
                  <br />
                  {/* <div className="direct-sales-label">Indirect Sales</div> */}
                </Col>
                <Col xl="6" md="6" sm="12" xs="12">
                  <div className="direct-indirect-sales-value">{totalFleetSalesZFM.direct_tbb}</div>
                  <br />
                  {/* <div className="direct-indirect-sales-value">{totalFleetSalesZFM.indirect_tbb}</div> */}
                </Col>
              </Row>

              <Row className="c-top-10" style={{ marginRight: '0px', marginLeft: '0px', background: 'white', paddingBottom: '10px', paddingTop: '10px' }}>
                <Col xl="6" md="6" sm="12" xs="12">
                  <div className="direct-sales-label">&nbsp;Total Sales</div>
                </Col>
                <Col xl="6" md="6" sm="12" xs="12">
                  <div className="direct-indirect-sales-value">&nbsp;&nbsp;{totalFleetSalesZFM.total_tbb}</div>
                </Col>
              </Row>

            </div>
          </Col>

          <Col xl="3" md="3" sm="12" xs="12">
            <div className={classnames({ 'mr-3': !this.isMobile }, 'fm-points-card total-points-card')} style={{ paddingBottom: '0px' }}>
              <Row>
                <Col xl="8" md="8" sm="12" xs="12">
                  <div className="fm-trucks">Total</div>
                </Col>
              </Row>

              <Row style={{ marginLeft: '7px', marginTop: '18px' }}>
                <Col xl="6" md="6" sm="12" xs="12">
                  <div className="direct-sales-label">Direct Sales</div>
                  <br />
                  {/* <div className="direct-sales-label">Indirect Sales</div> */}
                </Col>
                <Col xl="6" md="6" sm="12" xs="12">
                  <div className="direct-indirect-sales-value">{totalFleetSalesZFM.total_direct_sales}</div>
                  <br />
                  {/* <div className="direct-indirect-sales-value">{totalFleetSalesZFM.total_indirect_sales}</div> */}
                </Col>
              </Row>

              <Row className="c-top-10" style={{ marginRight: '0px', marginLeft: '0px', background: 'white', paddingBottom: '10px', paddingTop: '10px' }}>
                <Col xl="6" md="6" sm="12" xs="12">
                  <div className="direct-sales-label">&nbsp;Total Sales</div>
                </Col>
                <Col xl="6" md="6" sm="12" xs="12">
                  <div className="direct-indirect-sales-value">&nbsp;&nbsp;{totalFleetSalesZFM.total_sales}</div>
                </Col>
              </Row>

            </div>
          </Col>
        </Row>

        <Row className="c-top-20">
          <Col xl="9" md="9" sm="12" xs="12">
            <MemberSalesDetailDataTable
              fleetSalesZFM={fleetSalesZFM}
              getFleetSalesReportZFM={this.getFleetSalesReportZFM}
              queryParams={queryParams}
              handlePageClick={this.handlePageClick}
              reloadDataOnDelete={this.reloadDataOnDelete}
              userDetail={queryParams}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

export default withRouter(MemberSalesDetail);